import Container from './LeaderboardWrapper.container';
import LeaderboardWrapper from './LeaderboardWrapper';

export default Container(LeaderboardWrapper);
